import * as types from "./userTeamAudiosTypes";
import { omit } from "lib";

export const initState = null;

const userTeamAudiosReducers = (state = initState, action) => {
  switch (action.type) {
    // GET
    case types.USER_TEAM_AUDIOS_IN_FOLDER_REQUEST_SUCCESS:
    case types.USER_TEAM_AUDIOS_REQUEST_SUCCESS:
    case types.ALL_USER_TEAM_AUDIOS_REQUEST_SUCCESS: {
      let previousState = state || {};

      const { entities = {} } = action.response;

      const userTeamAudio = { ...entities.userTeamAudio };

      // Audio files don't need thumbnail URL preservation logic
      // since they don't have thumbnails

      return { ...previousState, ...userTeamAudio };
    }

    case types.ADD_USER_TEAM_AUDIOS_PLACEHOLDERS: {
      let previousState = state || {};

      // get the media placeholders
      const { mediaPlaceholders = [] } = action;

      // reduce into object and add isPlaceholder boolean flag
      const userTeamAudios = mediaPlaceholders.reduce(
        (allMedia, currentMedia) => ({
          ...allMedia,
          [currentMedia.mediaId]: {
            ...currentMedia,
            isPlaceholder: true
          }
        }),
        {}
      );

      return { ...previousState, ...userTeamAudios };
    }

    case types.UPDATE_USER_TEAM_AUDIO_PLACEHOLDER_PROGRESS: {
      const { mediaId, progress } = action;
      const existingAudio = state?.[mediaId];

      if (!existingAudio || !existingAudio.isPlaceholder) {
        return state;
      }

      return {
        ...state,
        [mediaId]: {
          ...existingAudio,
          uploadProgress: progress
        }
      };
    }

    // DELETE
    case types.USER_TEAM_AUDIO_DELETE_REQUEST: {
      return omit(state, action.request.mediaId);
    }
    case types.USER_TEAM_AUDIOS_DELETE_REQUEST: {
      return omit(state, action.extra.mediaIds);
    }

    // PUT
    case types.USER_TEAM_AUDIO_UPLOAD_REQUEST:
    case types.USER_TEAM_AUDIO_UPDATE_REQUEST: {
      const updatedAudioId =
        action.request.body.mediaId || action.request.body.id;

      // return existing audio entity if one is already stored in state
      if (state?.[updatedAudioId]) {
        return state;
      }

      return {
        ...state,
        [updatedAudioId]: action.request.body
      };
    }

    // POST
    case types.USER_TEAM_AUDIO_UPLOAD_REQUEST_SUCCESS:
    case types.USER_TEAM_AUDIO_UPDATE_REQUEST_SUCCESS: {
      const updatedAudio = { ...action.response };

      if (updatedAudio && updatedAudio.media && !updatedAudio.media.priority) {
        updatedAudio.media.priority = null;
      }

      return {
        ...state,
        [updatedAudio.mediaId]: {
          ...updatedAudio,
          origin: state[updatedAudio.mediaId]?.origin
        }
      };
    }

    default:
      return state;
  }
};

export default userTeamAudiosReducers;
